import React from 'react'
import { Alert, ShareIcon, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { getUpgradeBusinessAccountURL } from '../../../utils/app-utils'
import { getUserType } from '../../../utils/user-utils'
export const UserLimited = () => {
  const { user, confirmEmailLink } = useApplicationContext()
  const accountType = getUserType(user)
  let upgradeLink
  let message
  let linkText

  if (user?.userType === 'IDENTITY' || user?.userType === 'PERSONAL') {
    upgradeLink = getUpgradeBusinessAccountURL({ accountType })
    message = 'applications.account.limited'
    linkText = 'applications.account.upgrade'
  } else {
    upgradeLink = confirmEmailLink
    message = 'applications.account.notConfirmed'
    linkText = 'applications.account.confirm'
  }

  return (
    <div className="alert-block">
      <Alert type="info">
        <Message id={message} />{' '}
        <Link theme="v2" target="_blank" href={upgradeLink}>
          <Message id={linkText} />
          <ShareIcon size="sm" />
        </Link>
      </Alert>
    </div>
  )
}
